<template>
	<div class="pt-2">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<MultipleLineGanttChart
				:taskTitle="''"
				:tasks="workers"
				:taskArrayName="taskArrayName"
				:taskNameKey="'name'"
				:startDateKey="startDateKey"
				:endDateKey="endDateKey"
				:fontSize="fontSize"
				:taskBarStyle="taskBarStyle"
				:taskBarNameStyle="taskBarNameStyle"
				:colorRecognitionKey="'situation'"
				:taskBarColorsByRecognitionKey="taskBarColorsByRecognitionKey"
				:taskBarType="'bar'"
				:changeDatetimeFlag="authority_flag"
				showDates
				showCells
				onlyDateChartType
				barClickable
				@click-bar="openMenu($event)"
				@change-datetime="changeDatetime($event)"
			>
				<template v-slot:top-section>
					<v-row no-gutters justify="space-between">
						<ConstructionWorkerScheduleSearchDialog
							:query="q"
							:worker_query="worker_q"
							@search-constructions="searchConstructions($event)"
						/>
						<v-btn class="ml-2" color="secondary" @click="saveChangedProcesses"
							>変更を保存する</v-btn
						>
					</v-row>
				</template>
				<template v-slot:task-top-section>
					<v-col class="gantt-task" cols="5">所属</v-col>
					<v-col class="gantt-start" cols="2">外注</v-col>
					<v-col class="gantt-end" cols="5">作業者名</v-col>
				</template>
				<template v-slot:task-list="{ task }">
					<v-col class="task-name" cols="5">
						<!-- TODO 所属のカラム名 -->
						{{ task.associated_company.name }}
					</v-col>
					<v-col class="task-start" cols="2">
						<!-- TODO 外注の場合は⚪︎ -->
						{{ task.outsourcing }}</v-col
					>
					<v-col class="task-end" cols="5">
						<v-btn text @click="openWorkerDialog(task.id)">
							{{ task.full_name }}
						</v-btn>
					</v-col>
				</template>
				<template v-slot:task-name="{ task }">
					{{ task.construction.name }}
				</template>
			</MultipleLineGanttChart>
			<v-menu v-model="showMenu" :position-x="position.x" :position-y="position.y">
				<v-list>
					<v-list-item v-for="(item, i) in menuItems" @click="item.action" :key="i">{{
						item.name
					}}</v-list-item>
				</v-list>
			</v-menu>
			<ConstructionWorkerShowDialog :id="selectedWorkerId" :dialog.sync="dialog" />
			<ConstructionWorkerScheduleDialog
				:schedule="selectedSchedule"
				:constructions="constructions"
				:worker="selectedWorker"
				:dialog.sync="scheduleDialog"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import MultipleLineGanttChart from "../shared/MultipleLineGanttChart.vue"
import ConstructionWorkerScheduleDialog from "./worker_components/ConstructionWorkerScheduleDialog.vue"
import ConstructionWorkerShowDialog from "./worker_components/ConstructionWorkerShowDialog.vue"
import ConstructionWorkerScheduleSearchDialog from "./worker_components/ConstructionWorkerScheduleSearchDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"

export default {
	components: {
		CommonFlame,
		MultipleLineGanttChart,
		ConstructionWorkerScheduleDialog,
		ConstructionWorkerShowDialog,
		ConstructionWorkerScheduleSearchDialog,
		PaginationModule,
	},
	data() {
		return {
			title: "全体人員管理表",
			associated_companies: [],
			periods: [],
			constructions: [],
			workers: [], // モデル名不明
			taskArrayName: "days", // workersに紐づく日付の配列名
			startDateKey: "start_date",
			endDateKey: "end_date",
			authority_flag: false,
			fontSize: "14px",
			selectedSchedule: null,
			showMenu: false,
			position: {
				x: 0,
				y: 0,
			},
			menuItems: [
				{ action: this.renderToConstructionPage, name: "工事工程表" },
				{ action: this.openRequirementDialog, name: "工事依頼内容確認" },
				{ action: this.openScheduleDialog, name: "工事紐付け変更" },
			],
			dialog: false,
			taskBarStyle: {
				textAlign: "center",
				height: "24px",
				paddingBottom: "4px",
				borderRadius: 0,
			},
			taskBarNameStyle: {
				fontSize: ".9rem",
				color: "black",
			},
			taskBarColorsByRecognitionKey: {
				planned: this.$vuetify.theme.themes.light.rubber_process.requested,
				ongoing: this.$vuetify.theme.themes.light.rubber_process.ongoing,
				completed: this.$vuetify.theme.themes.light.rubber_process.completed,
			},
			q: {
				period_id_eq: null,
				name_cont: null,
				date_gteq: null,
				date_lteq: null,
			},
			worker_q: {
				associated_company_id_eq: null,
				name_cont: null,
			},
			changedProcesses: [],
			selectedWorker: null,
			selectedWorkerId: null,
			dialog: false,
			scheduleDialog: false,
			common,
			rules,
		}
	},

	mounted() {
		this.setQuery()
		// this.fetchConstructions()
		this.workers = [
			{
				associated_company: { name: "(株)XX" },
				outsourcing: "⚪︎",
				full_name: "XXX XXX",
				days: [
					{
						start_date: "2023-05-01",
						end_date: "2023-05-10",
						construction: {
							name: "XXXX",
						},
					},
					{
						start_date: "2023-05-01",
						end_date: "2023-05-15",
						construction: {
							name: "XXXX工事",
						},
					},
				],
			},
			{
				associated_company: { name: "XXXX" },
				outsourcing: "",
				full_name: "XXX XXX",
				days: [
					{
						start_date: "2023-05-01",
						end_date: "2023-05-10",
						construction: {
							name: "XXXX工事",
						},
					},
					{
						start_date: "2023-05-17",
						end_date: "2023-05-20",
						construction: {
							name: "XXXX工事",
						},
					},
				],
			},
			{
				associated_company: { name: "(株)XX" },
				outsourcing: "⚪︎",
				full_name: "XXX XXX",
				days: [
					{
						start_date: "2023-05-01",
						end_date: "2023-05-10",
						construction: {
							name: "XXXX",
						},
					},
					{
						start_date: "2023-05-18",
						end_date: "2023-05-25",
						construction: {
							name: "XXXX工事",
						},
					},
				],
			},
			{ associated_company: { name: "XXXX" }, outsourcing: "", full_name: "XXX XXX", days: [] },
			{ associated_company: { name: "XXXX" }, outsourcing: "", full_name: "XXX XXX", days: [] },
			{
				associated_company: { name: "(株)XX" },
				outsourcing: "⚪︎",
				full_name: "XXX XXX",
				days: [],
			},
			{ associated_company: { name: "(株)XX" }, outsourcing: "", full_name: "XXX XXX", days: [] },
		]
	},
	methods: {
		fetchConstructions() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/workers/schedules`
			const params = { q: this.q, worker_q: this.worker_q }
			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					this.construction = res.data.construction
					this.construction_process_types = res.data.construction_process_types
					this.workers = res.data.construction_processes
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		searchConstructions(params) {
			this.q = params.q
			this.worker_q = params.worker_q
			this.fetchConstructions()
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		renderToConstructionPage() {},
		openRequirementDialog() {},
		openScheduleDialog() {
			this.scheduleDialog = true
		},
		confirmSave(event) {
			event.returnValue = "変更したデータは保存されませんが、よろしいですか？"
		},
		changeDatetime(newProcess) {
			let params

			// 全てを表示している場合は適当した日時を絞り込む
			params = {
				[this.startDateKey]: newProcess[this.startDateKey],
				[this.endDateKey]: newProcess[this.endDateKey],
				id: newProcess.id,
			}
			let oldParams = this.changedProcesses.find((p) => p.id == params.id)
			if (oldParams) {
				let paramsIndex = this.changedProcesses.indexOf(oldParams)
				Object.keys(params).forEach((key) => {
					oldParams[key] = params[key]
				})
				this.changedProcesses[paramsIndex] = oldParams
			} else {
				this.changedProcesses.push(params)
			}

			let process = this.workers.find((p) => p.id == params.id)
			if (!process) return
			Object.keys(params).forEach((key) => {
				process[key] = params[key]
			})
			let index = this.workers.indexOf(process)
			this.workers[index] = process
			window.addEventListener("beforeunload", this.confirmSave)
		},
		saveChangedProcesses() {
			// TODO
			const headers = authenticate.setHeader()
			const params = {}
			const url = ``
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					res.data.forEach((process) => {
						this.updateRubberProcess(process)
					})
					this.changedProcesses = []
					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMenu(item) {
			console.log(item)
			this.showMenu = true
			this.position = { x: event.clientX, y: event.clientY }
			this.selectedSchedule = item.task
			this.selectedWorker = item.taskLine
		},
		openWorkerDialog(id) {
			this.selectedWorkerId = id
			this.dialog = true
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
	computed: {},
	destroyed() {
		window.removeEventListener("beforeunload", this.confirmSave)
	},
	beforeRouteLeave(to, from, next) {
		if (!this.changedProcesses.length) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
			return
		}
		const answer = window.confirm("変更したデータは保存されませんが、よろしいですか？")
		if (answer) {
			window.removeEventListener("beforeunload", this.confirmSave)
			next()
		} else {
			next(false)
		}
	},
}
</script>
